import Furniture from './Furniture';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Stump extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isEmpty = true;
  }

  createAsset() {
    this.asset = this.game.make.image(0, 0, this.data.key, 'stump');
    this.asset.anchor.set(0.5, 1);

    this.addChild(this.asset);
  }

  /*
  setNight(instant) {
    this.setNight2(instant);
  }

  setDay() {
    this.setDay2();
  }
  */

  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.asset.tint = this.tintColor;
  }
}
